<template>
    <div class="row recent-orders">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>SOT/FFL Approval Queue</h3>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th>Dealer</th>
                        <th>File Name</th>
                        <th>File Type</th>
                        <th>Uploaded By</th>
                        <th>Uploaded At</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in files">
                        <td>
                            {{ file.location.name }}
                        </td>
                        <td>
                            {{ file.file_name }}
                        </td>
                        <td>
                            {{ file.type }}
                        </td>
                        <td>
                            {{ file.uploader.name }}
                        </td>
                        <td>
                            {{ file.created_at }}
                        </td>
                        <td style="" class="text-right">
                            <a :href="file.attachment" target="_blank">
                                <span class="px-1 view-action"
                                    ><i
                                        class="fa fa-eye"
                                        aria-hidden="true"
                                    ></i>
                                    VIEW<br
                                /></span>
                            </a>
                            <a :href="file.attachment" download>
                                <span class="px-1 view-action"
                                    ><i
                                        class="fa fa-download"
                                        aria-hidden="true"
                                    ></i>
                                    DOWNLOAD</span
                                >
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    emits: [],
    components: {},
    setup() {},
    data() {
        return {
            files: [],
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.getFiles();
    },
    methods: {
        getFiles() {
            window.emitter.emit("changeLoaderStatus", true);
            axios
                .get("/api/get-all-location-files")
                .then((response) => {
                    if (response.data.length > 0) {
                        this.files = response.data;
                    }
                })
                .finally(() => {
                    window.emitter.emit("changeLoaderStatus", false);
                });
        },
    },
};
</script>
